import { Helmet } from 'react-helmet';
import '../assets/styles/Locations.css';

function Locations() {
  return (
    <>
      <Helmet>
        <title>RFF Cargo: Locations</title>
        <meta name="description" content="Explore RFF Cargo’s global network of logistics locations." />
      </Helmet>
      <section className="locations-section py-5">
        <div className="container">
          <h2 className="locations-title fw-bold mb-4">Our Locations</h2>
          <p className="locations-description">
            RFF Cargo operates in key locations worldwide to serve your logistics needs.
          </p>
          <div className="row">
            <div className="col-md-6 mb-4">
              <h3 className="location-title">Mombasa, Kenya</h3>
              <p className="location-text">Nyerere Road, Palli House</p>
            </div>
            {/* Add more locations as needed */}
          </div>
          <a href="#" className="btn btn-learn-more mt-3">View All Locations</a>
        </div>
      </section>
    </>
  );
}

export default Locations;